<template>
  <div class="padding text-center vertical layout center">
    <div
      class="img-slide"
      v-if="!$store.state.slide.showIframe && $store.state.slide.publishedLink"
    >
      {{ $t("seeSlideOnPresenterScreen") }}
    </div>
    <div
      class="google-slides-content"
      :class="{'no-control-box': !_hasControlBox()}"
      v-if="$store.state.slide.showIframe && $store.state.slide.publishedLink"
    >
      <iframe
        class="
      google-slides-iframe"
        :src="$store.state.slide.publishedLink"
        frameborder="0"
        width="668"
        height="375.75"
        v-if="$store.state.slide.publishedLink"
      />
    </div>
    <div class="no-data" v-if="!$store.state.slide.publishedLink">
      <p class="mb-3">
        {{ $t("blankSlide") }}
      </p>
    </div>
    <!-- Reactions -->
    <Reaction />
  </div>
</template>
<script>
import Reaction from '@/components/Reaction.vue'

export default {
  components: {
    Reaction,
  },
  methods: {
    _hasControlBox() {
      const { publishedLink } = this.$store.state.slide
      const controlBoxIndex = publishedLink.indexOf('&rm=minimal')
      if (controlBoxIndex !== -1) {
        return false
      }
      return true
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";
@media (max-width: 714px) {
  .padding {
      padding: 16px 0;
  }
  .google-slides-content {
    overflow: unset !important;
    padding-top: 0 !important;
    position: unset !important;
    width: 100%;
    height: calc(56.25vw + 29px);
    &.no-control-box {
      height: 56.25vw;
    }
    .google-slides-iframe {
      position: unset !important;
      top: unset !important;
      left: unset !important;
    }
  }
}

.google-slides-content {
  overflow: hidden;
  padding-top: 60.25%;
  position: relative;
  width: 100%;
  &.no-control-box {
    padding-top: 56.25%
  }
  .google-slides-iframe {
    position: absolute;
    top: 0;
    left: 0;
    border: 0;
    width: 100%;
    height: 100%;
  }
}
</style>
